export const validation = (value) =>
  value.match(/^(?:\d{0,3}\.\d{0,3})$|^\d{0,3}$/);
